import { Component, OnInit, Output, Input, EventEmitter, forwardRef } from '@angular/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { _HttpClient } from 'src/app/core/net/http.client';
import { ApiService } from 'src/app/core/net/apiRoute';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-departments',
  templateUrl: './app-select-departments.component.html',
  styleUrls: ['./app-select-departments.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectDepartmentsComponent),
      multi: true,
    }
  ]
})
export class AppSelectDepartmentsComponent implements OnInit, ControlValueAccessor {
  nzMultiple: false;                         // 支持多选（当设置 nzCheckable 时自动变为true）
  nzDefaultExpandAll: true;                  // 默认展开所有树节点
  nzShowSearch: true;                       // 显示搜索框
  nzDisabled: false;
  @Input() defaultValue;

  private _organizeId;
  @Input() get organizeId() {
    return this._organizeId;
  }
  
  set organizeId(value) {
    if (this._organizeId == value) {
      return;
    }
    this._organizeId = value;
    if (this.defaultValue) {
      this.defaultValue = null;
      this.propagateChange(null);
    }
    this.loadData();
  }                   // 输入值 组织机构Id
  @Input() nzCheckable: false;              // 节点前添加 Checkbox 复选框
  @Output() selectedEvent: EventEmitter<string> = new EventEmitter(); // 输出属性
  constructor(private http: _HttpClient) { }
  propagateChange = (_: any) => { };
  writeValue(obj: any): void {
    this.defaultValue = obj;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }


  nodes = [];   // 数据源

  // 下拉项改变
  onChange(value): void {
    this.propagateChange(value);
    this.selectedEvent.emit(value);

  }

  ngOnInit(): void {

  }

  // 加载数据
  loadData(): void {
    this.http.get(ApiService.GetDepartmentsTree, {
      organizeId: this.organizeId
    }, false)
      .subscribe((res: any) => {
        this.nodes = res.Result;
      });
  }

  ngOnchanges() {

  }
}
